import { Button, Card } from "antd";
import accountPendingImage from "assets/account-pending.png";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./styles.module.css";

export const AccountPendingScreen: React.FC = () => {
  const navigate = useNavigate();
  const state = useLocation().state as { email: string };

  useEffect(() => {
    if(!state?.email) {
      navigate("/login", {
        replace: true
      });
    }
  }, [state, navigate]);

  if(!state?.email) {
    return null;
  }

  return (
    <div className={classes.mainContainer}>
      <Card
        className={classes.card}
        classNames={{
          body: classes.container
        }}
      >
        <div className={classes.imageContainer}>
          <img src={accountPendingImage} alt="account-pending" width={300} height={300} />
        </div>

        <h2 className={classes.infoTitle}>You're almost there</h2>
        <p className={classes.infoText}>
          Your application is being reviewed. You'll receive an email once your account has been
          approved.
        </p>

        <Button
          className={classes.actionButton}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => navigate("/login", {
            replace: true
          })}
        >Got it</Button>
      </Card>
    </div>
  );
};
